import eventEnable from '../core/eventEnable';
import styleFromObject from '../ui_core/styleFromObject';
import EventNames from './WindowEventNames';
import './Windows.css';
var Windows = new (function () {
    const self = this;
	const NEW_WINDOW_POSITION_OFFSET=20;
    this._instances = [];
	var zIndexOffset=100;
    this.currentBounds = {minYPx: 0, maxYPx: 1200, minXPerc: 0, maxXPerc: 100};
	eventEnable(this);
    this.getActive = function ()
    {
		return self._instances.length<1?null:self._instances[self._instances.length-1];
    };
    this.getStartPosition = function (window)
    {
		let mostActiveWindowNotThisWindow = null;
		const parentElement = window.getParentElement();
		for(var i = self._instances.length - 1; i>=0; i--){
			mostActiveWindowNotThisWindow = self._instances[i];
			if(parentElement!==undefined&&parentElement!==null){
				if(mostActiveWindowNotThisWindow.getParentElement()!==parentElement)
					continue;
			}
			if(mostActiveWindowNotThisWindow!==window)break;
		}
		if(!mostActiveWindowNotThisWindow)return [0,0];
		const otherWindowPosition = mostActiveWindowNotThisWindow.getPosition();
		return [otherWindowPosition[0]+NEW_WINDOW_POSITION_OFFSET, otherWindowPosition[1]+NEW_WINDOW_POSITION_OFFSET];
	};
    window.addEventListener("resize", function () {
        for (var i = 0; i < self._instances.length; i++)
        {
            self._instances[i]._screenResized();
        }
    }, false);
	
    this.divDragHeightTaskBarPx = document.documentElement.clientHeight / 12;
	this._updateZIndices = function (){
		var zIndex = zIndexOffset;
		for (var i = 0; i < self._instances.length; i++)
		{
			self._instances[i]._setZIndex(zIndex);
			zIndex++;//xxx not right and need to wrap window and internal object in object inside instances.
		}
	};
    function isWindow(obj)
    {
		for(var i=0; i<self._instances.length; i++){
			var instance = self._instances[i];
			if(instance.public==obj)
				return true;
		}
		return false;
    }
	this.sendToBack = function(window){
		const instances = Windows._instances;
		instances.splice(0, 0, instances.splice(instances.indexOf(window), 1)[0]);
		Windows._updateZIndices();
	};
	this._dispatchWindowCreatedEvent = function(window){
		self.dispatchEvent({type:EventNames.WINDOW_CREATED, window:window});
	}
	this._dispatchWindowDestroyedEvent = function(window){
		self.dispatchEvent({type:EventNames.WINDOW_DESTROYED, window:window});
	}
    function focusFrontWindow(){
        self._instances[self._instances.length-1].focus();
    }
})();
export default Windows;
